import { render, staticRenderFns } from "./ProductWrapper.vue?vue&type=template&id=4712769a&"
import script from "./ProductWrapper.vue?vue&type=script&lang=js&"
export * from "./ProductWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports